import React from "react"
import withUseRouter, { UseRouterParams } from "services/router"
import {
	MatesComponent,
	MatesComponentState,
} from "components/mates-component"
import { Box } from "@mui/material"
import { PageHeader, RoutesData } from "components/commons"
import {
	ErrorResponse,
	Loading,
	RestResponse,
} from "@sinossi/mates-react-library"
import {
	CreateNewProposals,
	ViewSentProposals,
} from "components/match-proposal"
import { MatchService } from "services/match.service"
import { AssetMatchBrand } from "models"

interface MatchProposalCreationProps extends UseRouterParams {

}

interface MatchProposalCreationState extends MatesComponentState {
	loading: boolean
	visibleMatches: AssetMatchBrand[]
	notVisibleMatches: AssetMatchBrand[]
	assetId: string
}

class MatchProposalCreation extends React.Component<MatchProposalCreationProps, MatchProposalCreationState> {
	private readonly matesComponent: MatesComponent<MatchProposalCreationProps, MatchProposalCreationState> = new MatesComponent(this)

	constructor(props: MatchProposalCreationProps)
	{
		super(props)
		this.state = {
			...this.matesComponent.setupState(),
			assetId: window.location.href.split("/")[window.location.href.split("/").length - 1],
			loading: true,
			visibleMatches: [],
			notVisibleMatches: []
		}
	}

	componentDidMount() {
		this.getVisibleMatches()
	}

	private getVisibleMatches = () => {
		MatchService.getVisibleMatch(this.state.assetId, this.getVisibleMatchCallback, this.matesComponent.onError)
	}

	private getVisibleMatchCallback = (response: RestResponse<AssetMatchBrand[], ErrorResponse>) => {
		if(response.hasError()){
			this.matesComponent.onError(response)
			this.setState(() => ({
				loading: false
			}))
		}

		if(response.data){
			this.setState(() => ({
				visibleMatches: response.data || []
			}), this.getNotVisibleMatches)
		}
	}

	private getNotVisibleMatches = () => {
		MatchService.getNotVisibleMatch(this.state.assetId, this.getNotVisibleMatchCallback, this.matesComponent.onError)
	}

	private getNotVisibleMatchCallback = (response: RestResponse<AssetMatchBrand[], ErrorResponse>) => {
		if(response.hasError()){
			this.matesComponent.onError(response)
			this.setState(() => ({
				loading: false
			}))
		}

		if(response.data){
			this.setState(() => ({
				notVisibleMatches: response.data || [],
				loading: false
			}))
		}
	}

	render() {
		return (
			<Box sx={{ width: '100%', pt: 2, position: "relative" }}>
				<Loading show={this.state.loading} />
				<PageHeader
					title={RoutesData.MATCH_PROPOSAL_CREATION.title}
					paths={[RoutesData.DASHBOARD, RoutesData.MATCH_PROPOSAL, RoutesData.MATCH_PROPOSAL_CREATION]}
				/>
				<Box
					sx={{
						display: "flex",
						flexDirection: { xs: "column", lg: "row" },
						alignItems: "flex-start",
						justifyContent: "space-between",
						width: "100%",
						mt: 3,
						gap: 3,
						px: { xs: 1, sm: 2 }
					}}
				>
					<ViewSentProposals
						visibleMatches={this.state.visibleMatches}
					/>
					<CreateNewProposals
						notVisibleMatches={this.state.notVisibleMatches}
						refreshNotVisible={() => {this.setState(() => ({loading: true}), this.getNotVisibleMatches)}}
						refreshVisible={() => {this.setState(() => ({loading: true}), this.getVisibleMatches)}}
						assetId={this.state.assetId}
					/>
				</Box>
			</Box>
		)
	}
}

export default withUseRouter(MatchProposalCreation)
